import { useModelContext } from '@app/contexts/model';
import { useStorageConfirmTranslateContext } from '@app/modules/ConfirmTranslate/contexts/storage';
import { useStorageTranslateContext } from '@app/modules/Translate/contexts/storage';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';

interface IModalSuccessProps {}

export const ModalSuccess: FunctionComponent<IModalSuccessProps> = observer<FunctionComponent<IModalSuccessProps>>(function () {
    const { translateStore } = useStorageTranslateContext();
    const { languageFileModel } = useModelContext();
    const { confirmTranslateStore } = useStorageConfirmTranslateContext();

    let openModalSuccess = translateStore.openConfirmModalSuccess;

    return (
        <Dialog open={openModalSuccess} aria-describedby='alert-dialog-description'>
            <DialogContent>
                <DialogContentText id='alert-dialog-description'>Translation confirmed</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        translateStore.handleCloseConfirmModalSuccess();
                        if (translateStore.confirmTempFilesToDelete) {
                            languageFileModel.dataLanguage.set(null);
                            confirmTranslateStore.clear();
                            translateStore.clear();
                        }
                    }}
                    size={'small'}
                    color='primary'>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
});
